import { useEffect } from 'react';

export const useScrollTop = () => {
  useEffect(() => {
    document.querySelector('#root').scrollIntoView();
  }, []);
};
